import React from "react";
import { Popup, Segment, Header, Button } from "semantic-ui-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToasts } from "react-toast-notifications";
import { faLinkedin, faSquareFacebook, faSquareTwitter } from "@fortawesome/free-brands-svg-icons";
import "../routes/list.scss";

interface ISharePopup {
  contentUrl: string;
  headline: string;
  position: "top left" | "top right" | "bottom left" | "bottom right";
  trigger: JSX.Element;
  open: boolean;
  setOpen: any;
}

export const SharePopup = ({ trigger, contentUrl, headline, position, open, setOpen }: ISharePopup) => {
  const { addToast } = useToasts();

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setOpen(false);
      addToast(`Link copied to clipboard`, {
        appearance: "info",
        autoDismiss: true,
      });
    } catch (err) {
      addToast(`Copy to clipboard failed. Please try again`, {
        appearance: "error",
        autoDismiss: true,
      });
    }
  };
  return (
    <Popup
      on='click'
      flowing
      open={open}
      onClose={() => setOpen(false)}
      position={position}
      style={{ padding: 0 }}
      size='small'
      content={
        <Segment basic onClick={(event: React.MouseEvent<HTMLButtonElement>) => event.stopPropagation()}>
          <Header as='h4' content='Share Message' />
          <div className='share-message'>
            <Button
              basic
              content='Copy Link'
              icon='linkify'
              onClick={() => {
                copyToClipboard(contentUrl);
              }}
            />
            <Popup
              on='hover'
              inverted
              position='top center'
              mouseEnterDelay={500}
              content='Facebook'
              trigger={
                <FontAwesomeIcon
                  onClick={() =>
                    window.open(
                      `https://www.facebook.com/sharer/sharer.php?u=${contentUrl}&quote=${headline}`,
                      "_blank",
                    )
                  }
                  icon={faSquareFacebook}
                  size='3x'
                  style={{ color: "#465A94" }}
                />
              }
            />
            <Popup
              on='hover'
              inverted
              position='top center'
              mouseEnterDelay={500}
              content='Twitter'
              trigger={
                <FontAwesomeIcon
                  onClick={() => window.open(`https://twitter.com/intent/tweet?url=${contentUrl}`, "_blank")}
                  icon={faSquareTwitter}
                  size='3x'
                  style={{ color: "#5DA1EC" }}
                />
              }
            />
            <Popup
              on='hover'
              inverted
              position='top center'
              mouseEnterDelay={500}
              content='LinkedIn'
              trigger={
                <FontAwesomeIcon
                  onClick={() =>
                    window.open(`https://www.linkedin.com/sharing/share-offsite?url=${contentUrl}`, "_blank")
                  }
                  icon={faLinkedin}
                  size='3x'
                  style={{ color: "#0077B5" }}
                />
              }
            />
          </div>
        </Segment>
      }
      trigger={trigger}
    />
  );
};

export default SharePopup;
